<ng-container [ngSwitch]="column.type">
  <ng-template [ngSwitchCase]="columnTypes.String">
    <div class="cell-value text-ellipsis">{{ item[column.name] }}</div>
  </ng-template>

  <ng-template [ngSwitchCase]="columnTypes.Number">
    <div class="cell-value text-ellipsis">
      {{ item[column.name] }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="columnTypes.Boolean">
    <div class="cell-value text-ellipsis">
      {{ item[column.name] ? column['trueValue'] : column['falseValue'] }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="4">
    <div class="cell-value text-ellipsis">{{ item[column.name] | dateFormat }}</div>
  </ng-template>

  <ng-template [ngSwitchCase]="5">
    <div class="cell-value text-ellipsis">{{ item[column.name] | dateTimeFormat }}</div>
  </ng-template>

  <ng-template [ngSwitchCase]="6">
    <div class="cell-value text-ellipsis">{{ column['enumData'][item[column.name]] }}</div>
  </ng-template>

  <ng-template [ngSwitchCase]="7">
    <ng-template
      [ngTemplateOutlet]="column['template']"
      [ngTemplateOutletContext]="{ item: item, highlight: highlight }"
    ></ng-template>
  </ng-template>
</ng-container>
